<template>
	<div class="tpl send-trends-wrap">
		<mt-header title="" fixed>
			<router-link :to="{name:'trends'}" slot="left">
				<mt-button icon="back"></mt-button>
			</router-link>
			<mt-button class="send-btn" slot="right" @click.native="submitTrends">发布</mt-button>
		</mt-header>
		<div class="edit-box">
			<textarea v-model="trendText" id="trend-text" placeholder="你的想法..." autofocus></textarea>
			<div class="trend-imgs">
				<div class="img-box" v-for="(item,index) in imgs">
					<div class="img-box-inner">
						<input type="file" accept="image/*" name="" id="upload-img" @change="uploads" />
						<span v-if="!item" class="add-btn">+</span>
						<img v-if="item" :src="item" alt="" />
					</div>
					<span v-if="item" class="delete-btn" @click="deleteImg($event,index)">&times;</span>
				</div>
			</div>
		</div>
		<div class="options-list">
			<ul>
				<li>
					<div class="option-name">
						<img src="../../assets/img/trends/dyn_re_ic_pos.png"/>
						当前所在城市
					</div>
					<div class="option-value" style="text-align: right;">
						<p>{{address.city}}</p>
						<p>{{address.more}}</p>
					</div>
				</li>
				<li>
					<div class="option-name">
						<img src="../../assets/img/trends/dyn_re_ic_pe.png"/>
						谁可以看
					</div>
					<span class="option-value" @click="setVisible">{{trendVisible.name}}</span>
					<mt-actionsheet :actions="actions" v-model="sheetVisible"></mt-actionsheet>
				</li>
			</ul>
		</div>
		<div id="oe_map" style="height:18rem;"></div>
		<!--<get-position @getPosition="getPosition"></get-position>-->
	</div>
</template>

<script>
	import GetPosition from '../Common/GetPosition'
	export default {
		name: "send-trends",
		components:{
			GetPosition
		},
		data() {
			return {
				uid: "",
				fromPath: "", //来源路由
				imgs: [""],
				trendText:"",
				trendType:"",
				formData: new FormData(),
				trendVisible:{
					name:"公开",
					id:"1"
				},
				sheetVisible:false,
				actions:[
					{name:"公开",method:this.trendVisibleOne},
					{name:"私密",method:this.trendVisibleTwo},
					{name:"好友可见",method:this.trendVisibleThree}
				],
				address:{
					city:"",
					more:"",
					lat:"",
					lng:"",
				}
			}
		},
		created() {
			this.uid = this.$store.state.UserId; //获取当前用户的id
			this.$store.commit("changeTabChoosed", "trends");
			this.$store.commit("changeTabBarShow", false);
			
			this.address.city = this.$store.state.nowAddress;
			console.log(this.$store.state.nowAddress)
		},
		mounted(){
			let _this = this;
			
			var OE_MAP_ZOOM = 16;
			var map_obj = "";
			var map_geoc = "";
			var map_point = "";
			var map_marker = "";
			var OE_MAP_LNG = "";
			var OE_MAP_LAT = "";
			var $_init_display_marker = false;
			
			function _initOEmap() {
				$_init_display_marker = false;
				if(typeof(OE_MAP_LNG) == "undefined") {
					OE_MAP_LNG = "";
				}
				if(typeof(OE_MAP_LAT) == "undefined") {
					OE_MAP_LAT = "";
				}
				if(OE_MAP_LNG.length == 0) {
					OE_MAP_LNG = 120.592727;
				} else {
					$_init_display_marker = true;
				}
				if(OE_MAP_LAT.length == 0) {
					OE_MAP_LAT = 31.306407;
				}
				map_obj = new BMap.Map("oe_map");
				map_geoc = new BMap.Geocoder();    
				map_point = new BMap.Point(OE_MAP_LNG, OE_MAP_LAT);
				map_obj.centerAndZoom(map_point, OE_MAP_ZOOM);
				map_obj.addControl(new BMap.NavigationControl());
				map_obj.addControl(new BMap.ScaleControl());
				map_obj.addControl(new BMap.OverviewMapControl());
				map_obj.enableScrollWheelZoom();
				map_obj.addControl(new BMap.MapTypeControl());
				if($_init_display_marker == true) {
					map_marker = new BMap.Marker(new BMap.Point(OE_MAP_LNG, OE_MAP_LAT));
					map_marker.enableDragging();
					map_obj.addOverlay(map_marker);
					
					map_marker.addEventListener("dragend", function(e) {
						console.log(e)
						getAddInfo(e.point);
					});
				}
				if(map_marker) {
					map_obj.addOverlay(map_marker);
					map_marker.enableDragging();
					map_marker.addEventListener("dragend", function(e) {
						getAddInfo(e.point);
					});
				}
				map_obj.addEventListener("click", function(e) {
					map_obj.clearOverlays();
					map_marker = new BMap.Marker(new BMap.Point(e.point.lng, e.point.lat));
					map_marker.enableDragging();
					map_obj.addOverlay(map_marker);
					getAddInfo(e.point);
					map_marker.addEventListener("dragend", function(e) {
						getAddInfo(e.point);
					});
				});
			}
			
			function getAddInfo(obj){
				console.log(obj)
				_this.address.lng = obj.lng;
				_this.address.lat = obj.lat;
				map_geoc.getLocation(obj, function(rs){
					var addComp = rs.addressComponents;
					_this.address.city = addComp.city;
					_this.address.more = addComp.district+addComp.street+addComp.streetNumber;
				}); 
			}
			
			function _searchMap() {
				$_location_key = $("#maplocation").val();
				if($_location_key.length > 0) {
					map_obj.clearOverlays();
			
					function _getBDFirstMarker() {
						var pp = local.getResults().getPoi(0).point;
						map_obj.centerAndZoom(pp, OE_MAP_ZOOM);
						map_marker = new BMap.Marker(new BMap.Point(pp.lng, pp.lat));
						map_marker.enableDragging();
						map_obj.addOverlay(map_marker);
						getAddInfo(e.point);
						map_marker.addEventListener("dragend", function(e) {
							getAddInfo(e.point);
						});
					}
					var local = new BMap.LocalSearch(map_obj, {
						onSearchComplete: _getBDFirstMarker
					});
					local.search($_location_key);
				}
			}
			
			_initOEmap();
		},
		beforeRouteEnter(to, from, next) {
			next((vm) => { //参数vm就是当前组件的实例。
				vm.fromPath = from;
				console.log(vm.fromPath)
			})
		},
		methods: {
			getPosition(data){
				console.log(123);
				
			},
			setVisible(){
				this.sheetVisible = !this.sheetVisible;
			},
			trendVisibleOne(){
				this.trendVisible = {name:"公开",id:"1"}
			},
			trendVisibleTwo(){
				this.trendVisible = {name:"私密",id:"2"}
			},
			trendVisibleThree(){
				this.trendVisible = {name:"好友可见",id:"3"}
			},
			deleteImg(event,i) {
				let ele = event.currentTarget.previousElementSibling.childNodes[0];
				ele.value = "";
				this.imgs.splice(i,1)
			},
			uploads(e) {
				console.log(this.formData)
				const file = e.target.files[0];

				let URL = window.URL || window.webkitURL; // 与上传没有关系（可选）
				this.imgs.splice(this.imgs.length-1,0,URL.createObjectURL(file)) // 这是为了显示图片而已， 与上传没有关系（可选）
				console.log(this.imgs);
				this.formData.append('img[]', file); // 'file[]' 代表数组 其中`file`是可变的

				console.log(this.formData.get("img[]"))
			},
			submitTrends(){
				if(!this.isLogin()){return false;}
				if(this.imgs.length>1){
					this.trendType = 1;
				}else{
					this.trendType = 0;
				}
				this.formData.append('uid', this.uid);
				this.formData.append('text', this.trendText);
				this.formData.append('type', this.trendType);
				this.formData.append('visibility', this.trendVisible.id);
				this.formData.append('type_web', 1);
				this.formData.append('longitude', this.address.lng);
				this.formData.append('latitude', this.address.lat);
				this.formData.append('city', this.address.city);
				this.formData.append('address', this.address.more);
				console.log(this.formData.get("uid"));
				
				let config = {
		          	headers:{'Content-Type':'multipart/form-data'}
		        };
				this.$axios.post("Dynamic/ReleaseDynamic",this.formData,config).then(res=>{
					console.log(res);
					if(res.data.code==200){
						this.$toast({
							message: res.data.msg,
							position: "bottom",
							duration: 3000
						});
						this.$router.push({
							name:"trends"
						})
					}
				}).catch(err=>{
					console.log(err)
				})
			}
		}
	}
</script>

<style scoped>
	#oe_map{
		width: 100%;
		border: 1px solid #f3f3f3;
		padding: 1rem;
	}
	>>>.anchorBL,>>>.anchorTR{
		display: none
	}	
	>>>.mintui.mintui-back{
		color: #ccc;
	}
	>>>.mint-button-text {
		color: #787878;
	}
	
	.send-trends-wrap {
		padding-top: 3rem;
		background: #fff;
	}
	
	.edit-box {
		padding: 0 1rem;
	}
	
	.edit-box textarea {
		width: 100%;
		max-width: 100%;
		min-width: 100%;
		max-height: 5rem;
		min-height: 5rem;
		height: 5rem;
		display: block;
		padding: 0.5rem;
		font-size: 0.8rem;
		line-height: 1.2rem;
		border: 1px solid #fafafa;
		outline: 0;
		border-radius: 5px;
	}
	
	.trend-imgs {
		padding: 1rem 0;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		flex-wrap: wrap;
	}
	
	.trend-imgs .img-box {
		width: 33%;
		padding: 0.5rem;
		height: 7rem;
		position: relative;
	}
	
	.trend-imgs .img-box-inner {
		width: 100%;
		height: 100%;
		border-radius: 5px;
		overflow: hidden;
		background: #f4f4f4;
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;
	}
	
	.trend-imgs .img-box-inner img {
		max-width: 100%;
		max-height: 100%;
	}
	
	.trend-imgs .img-box-inner input {
		width: 100%;
		height: 100%;
		opacity: 0;
		position: absolute;
		z-index: 10;
	}
	
	.trend-imgs .img-box .delete-btn {
		position: absolute;
		top: 0;
		right: 0;
		width: 1rem;
		height: 1rem;
		border-radius: 50%;
		background: red;
		color: #fff;
		text-align: center;
		line-height: 1rem;
	}
	
	.trend-imgs .img-box-inner .add-btn {
		position: absolute;
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 3rem;
		color: #ccc;
		font-weight: lighter;
	}
	.options-list{
		border-top: 1px solid #f3f3f3;
    	border-bottom: 1px solid #f3f3f3;
	}
	.options-list li{
		display: flex;
	    justify-content: space-between;
	    align-items: center;
	    padding: 0.5rem 2rem;
	    font-size: 0.8rem;
	    color: #282828;
	}
	.options-list li:first-of-type{
		border-bottom: 1px solid #f9f9f9;
	}
	.options-list .option-name{
	    display: flex;
	    justify-content: flex-start;
	    align-items: center;
	}
	.options-list .option-name img{
		width: 1.2rem;
		margin-right: 0.2rem;
	}
	
</style>


// WEBPACK FOOTER //
// src/components/Trends/SendTrends.vue